export function getCloserScrollElement(curElement) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'vertical';
  var clientOpt = 'clientHeight';
  var scrollOpt = 'scrollHeight';
  var targetElement = curElement;

  if (direction === 'horizontal') {
    clientOpt = 'clientWidth';
    scrollOpt = 'scrollWidth';
  }

  while (targetElement !== document.documentElement && targetElement.parentElement && targetElement[scrollOpt] <= targetElement[clientOpt]) {
    targetElement = targetElement.parentElement;
  }

  return targetElement;
}
export function findTargetElementsParent(fromNode, nodes) {
  return nodes.some(function (item) {
    return !!(item && item.contains(fromNode));
  });
}